import { useUpdateEmojiReactionsMutation } from '@/hooks/use-update-emoji-reactions-mutation.ts';
import { useUser } from '@/hooks/use-user';
import { emojiReactionsStore } from '@/models/stores';
import { EmojiReactionType } from '@/models/types';

export function useEmojiReactions(
  targetId: string,
  targetType: EmojiReactionType,
) {
  const user = useUser();
  const { updateEmojiReactionsMutation } = useUpdateEmojiReactionsMutation();

  const toggle = (emoji: string) => {
    const { action, id } = emojiReactionsStore.toggle(
      targetId,
      targetType,
      user.id,
      emoji,
    );

    updateEmojiReactionsMutation.mutate(
      {
        emojiReactionPayload: {
          id,
          emoji,
          targetId,
          targetType,
          userId: user.id,
        },
        action,
      },
      {
        onError: () => {
          emojiReactionsStore.toggle(targetId, targetType, user.id, emoji);
        },
      },
    );
  };

  const summary = emojiReactionsStore.getEmojiSummaryForTarget(
    targetId,
    targetType,
    user.id,
  );
  return { summary, toggle, user };
}
